export default __webpack_public_path__ + "static/media/eleanor holmes norton.5ba113fc.jpg";